module.exports = __webpack_public_path__ + "static/media/raw.0508e5c8.svg";